import { Spinner, Stack } from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { AuthenticationState } from "react-aad-msal";

import AuthenticationProvider from "./AuthenticationProvider";

export type IAuthenticationProps = {
  provider: AuthenticationProvider;
  forceLogin?: boolean;
};

export const Authentication: React.FC<IAuthenticationProps> = ({ provider, forceLogin, children }) => {
  const [authenticationState, setAuthenticationState] = useState(provider.authenticationState);

  const login = useCallback(() => {
    provider.login();
  }, [provider]);

  // On mount, register the authenticationState hook with the new Auth Provider
  // so that the render can know what state of authentication we are in
  useEffect(() => {
    provider.registerAuthenticationStateHandler(setAuthenticationState);

    if (forceLogin && provider.authenticationState === AuthenticationState.Unauthenticated) login();

    return () => {
      provider.unregisterAuthenticationStateHandler(setAuthenticationState);
    };
  }, [provider, forceLogin, login]);

  switch (authenticationState) {
    case AuthenticationState.Unauthenticated:
      return (
        <Stack horizontalAlign="center" verticalAlign="center" styles={{ root: { height: "100vh" } }}>
          <h3>You are not signed in...</h3>
        </Stack>
      );
    case AuthenticationState.InProgress:
      return (
        <Stack verticalAlign="center" styles={{ root: { height: "100vh" } }}>
          <Spinner label="Authenticating..." />
        </Stack>
      );
    case AuthenticationState.Authenticated:
      return <>{children}</>;
    default:
      return <React.Fragment />;
  }
};
